import {useTranslation} from '#imports';
import type {JoyIconsId} from '@malt/joy-entrypoint/node_modules/@maltjoy/icons/dist/joy-icons';
import type {ExpenseCategory} from '@api';

export function useExpenseCategoryMapper() {
    const {t} = useTranslation();

    const categoriesLabels: Record<ExpenseCategory, string> = {
        TRANSPORTATION: t('projectclient.expenses.info.category.TRANSPORTATION'),
        MEAL: t('projectclient.expenses.info.category.MEAL'),
        ACCOMMODATION: t('projectclient.expenses.info.category.ACCOMMODATION'),
        MILEAGE_ALLOWANCE: t('projectclient.expenses.info.category.MILEAGE_ALLOWANCE'),
        PHONE: t('projectclient.expenses.info.category.PHONE'),
        CONFERENCE: t('projectclient.expenses.info.category.CONFERENCE'),
        TAXI: t('projectclient.expenses.info.category.TAXI'),
        CAR_RENTAL: t('projectclient.expenses.info.category.CAR_RENTAL'),
        CAR_RENTAL_FUEL: t('projectclient.expenses.info.category.CAR_RENTAL_FUEL'),
        PARKING: t('projectclient.expenses.info.category.PARKING'),
        TOLLS: t('projectclient.expenses.info.category.TOLLS'),
        SOFTWARE_HARDWARE: t('projectclient.expenses.info.category.SOFTWARE_HARDWARE'),
        MISCELLANEOUS: t('projectclient.expenses.info.category.MISCELLANEOUS'),
    };

    const categoriesIcons: Record<ExpenseCategory, JoyIconsId> = {
        TRANSPORTATION: 'transportation',
        MEAL: 'meal',
        ACCOMMODATION: 'accomodation',
        MILEAGE_ALLOWANCE: 'car',
        PHONE: 'phone',
        CONFERENCE: 'conference',
        TAXI: 'taxi',
        CAR_RENTAL: 'car-allowance',
        CAR_RENTAL_FUEL: 'gasoline',
        PARKING: 'car-garage',
        TOLLS: 'home',
        SOFTWARE_HARDWARE: 'code',
        MISCELLANEOUS: 'user',
    };

    return {
        categoriesLabels,
        categoriesIcons,
    };
}
